import {
  InputLabel,
  InputLabelProps,
  Typography,
  styled,
  useTheme,
} from '@mui/material';
import { typographyCss } from 'theme/typography-css';

export const InputLabelStyled = styled(
  ({ children, ...props }: InputLabelProps) => {
    const theme = useTheme();
    return (
      <InputLabel
        sx={{ transform: 'none', transition: 'none' }}
        shrink
        {...props}
      >
        <Typography
          sx={{
            ...typographyCss(theme, 'body2'),
            fontSize: '.75rem',
            fontWeight: 700,
          }}
        >
          {children}
        </Typography>
      </InputLabel>
    );
  },
)(() => ({}));
